import { render, staticRenderFns } from "./word_mobile.vue?vue&type=template&id=623c022c&scoped=true&"
import script from "./word_mobile.vue?vue&type=script&lang=js&"
export * from "./word_mobile.vue?vue&type=script&lang=js&"
import style0 from "./word_mobile.vue?vue&type=style&index=0&id=623c022c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623c022c",
  null
  
)

export default component.exports